module.exports = __webpack_public_path__ + "media/scholarship_winners/winner-sprites_24x24-29a3139a.png";